<style lang="scss" scoped>
.card {
  height: 80vh;
  position: relative;
}

.partner-content {
  height: calc(80vh - 90px);
}

.dialog-content-wrapper {
  width: 100%;
  display: none;
}

.dialog-content.content-wrapper {
  height: calc(100% - 33px);
}

.dialog-content-wrapper .dialog-partner-info {
  display: none;
}

@media (min-width: 768px) {
  .partner-content {
    height: calc(80vh - 51px);
  }

  .dialog-content-wrapper {
    width: calc(100% - 18rem);
    display: block;
  }

  .dialog-content-wrapper .dialog-partner-info {
    display: flex;
  }

  .dialog-content.content-wrapper {
    height: calc(100% - 80px);
  }
}
</style>

<template>
  <div class="card mb-3">
    <div class="card-header bg-primary text-white">Nachrichten</div>
    <div class="flex-row d-md-none">
      <div class="d-flex">
        <button
          type="button"
          class="btn btn-primary btn-success flex-fill rounded-0 w-50"
          :class="{ active: showPartner }"
          @click="toggleView('messages')"
        >
          Kontakte
        </button>
        <button
          type="button"
          class="btn btn-secondary btn-success flex-fill rounded-0 w-50"
          :class="{ active: showContent }"
          @click="toggleView('chat')"
        >
          Nachrichten
        </button>
      </div>
    </div>
    <div class="d-flex partner-content">
      <chat-dialogs
        :activeDialogPartnerId="activeDialogPartnerId"
        @display-chat="displayChat"
        @load-more-dialogs="loadDialogs"
        :loading="loadingPartners"
        :dialogPartners="dialogPartner"
        :showPartner="showPartner"
        :showSupportMessages="showSupportMessages"
      ></chat-dialogs>
      <div
        v-if="hasDialogPartner"
        class="flex-grow-1 dialog-content-wrapper"
        :class="{ 'd-block': displayContent }"
      >
        <dialog-partner-info
          class="dialog-partner-info"
          :class="{ 'd-flex': displayDialogInfo }"
          :id="currentPartner.id"
        ></dialog-partner-info>
        <div
          class="p-1 text-center border-bottom d-md-none btn d-block"
          @click="displayDialogInfo = !displayDialogInfo"
        >
          {{ partnerInfoText }}
        </div>
        <dialog-content
          class="dialog-content"
          :class="{ 'd-none d-md-flex': displayDialogInfo }"
          :support="showSupportMessages"
          :idPartner="activeDialogPartnerId"
          :profile="me.customer_profile"
          :moderator="false"
          :hideInputs="hideInputs"
        ></dialog-content>
      </div>
    </div>
  </div>
</template>

<script lang="babel">
import ChatDialogs from '@/components/Customer/chat/ChatDialogs.vue';
import DialogContent from '@/components/Customer/chat/DialogContent.vue';
import DialogPartnerInfo from '@/components/Customer/DialogPartnerInfo.vue';
import { subscribe, urlBase64ToUint8Array } from "@/pushNotification";

export default {
  components: {
    ChatDialogs,
    DialogContent,
    DialogPartnerInfo
  },
  data() {
    return {
      showPartner: true,
      showContent: false,
      showSupportMessages: false,
      activeDialogPartnerId: null,
      loadingPartners: false,
      skip: 0,
      take: 10,
      displayDialogInfo: false
    };
  },
  async created() {
    await this.loadDialogs();
    this.activeDialogPartnerId = await this.chatButtonRedirect();
    if(this.currentPartner)
      this.displayChat(this.currentPartner);
    if (navigator.serviceWorker) {
      this.pushSubcribtion();
    }
  },
  methods: {
    pushSubcribtion() {
      navigator.serviceWorker.ready.then(registration => {
        const options = { userVisibleOnly: true };
        const vapidPublicKey = window.Laravel.vapidPublicKey;

        if (vapidPublicKey) {
          options.applicationServerKey = urlBase64ToUint8Array(vapidPublicKey);
        }
        if (registration.pushManager) {
          registration.pushManager.permissionState(options).then(data => {
            if (data != 'granted' && data != 'denied') {
              subscribe();
            }
          });
        }
      });
    },
    scrollBottom() {
      this.$refs.content.scrollTop = this.$refs.content.scrollHeight;
    },
    async chatButtonRedirect() {
      let param = new RegExp('[?&]id=([^&#]*)').exec(window.location.href);
      const newChatUserId = Number(param ? param[1] : 0);

      if (newChatUserId) {
        const dialogs = this.dialogPartner.filter(partner => partner.id === newChatUserId);
        if (dialogs.length > 0) return dialogs[0].id;
        const customerProfile = await this.$store.dispatch('dialog/newTempDialog', newChatUserId);
        return customerProfile ? customerProfile.id : null;
      }
    },
    toggleView(type) {
      if (type === 'chat') {
        this.showContent = true;
        this.showPartner = false;
      } else {
        this.showContent = false;
        this.showPartner = true;
      }
    },
    displayChat(partner) {
      if (!partner.deleted_at && partner.is_support) {
        this.showSupportMessages = true;
      } else {
        this.showSupportMessages = false;
      }

      this.activeDialogPartnerId = partner.id;
      let newRelativePathQuery = window.location.pathname + '?id=' + this.activeDialogPartnerId;
      history.pushState(null, '', newRelativePathQuery);
      this.toggleView('chat');
    },
    async loadDialogs() {
      this.loadingPartners = true;
      let readRequest = this.$store.dispatch("dialog/read", [
        {
          name: "skip",
          value: this.skip
        },
        {
          name: "take",
          value: this.take
        },
      ])
      .then(() => {
        this.skip = this.skip + this.take;
      });
      let countRequest = this.$store.dispatch("dialog/count");

      await Promise.all([countRequest, readRequest])
        .finally(() => {
          this.loadingPartners = false;
        });
    }
  },
  computed: {
    me() {
      return this.$store.getters["user/me"];
    },
    dialogPartner() {
      const dialogs = this.$store.getters["dialog/dialogs"].slice(0);
      return dialogs.sort((a, b) => {
        if (!b.last_message) {
          return 1;
        }

        if (!a.last_message) {
          return -1;
        }
        return new Date(b.last_message.created_at) - new Date(a.last_message.created_at)
      });
    },
    hasDialogPartner() {
      return Boolean(this.activeDialogPartnerId) || this.showSupportMessages;
    },
    displayContent() {
      return this.showContent && this.hasDialogPartner;
    },
    currentPartner() {
      if (!this.hasDialogPartner) {
        return;
      }
      return this.dialogPartner.find(dialogPartner => dialogPartner.id === this.activeDialogPartnerId);
    },
    hideInputs() {
      if (!this.hasDialogPartner || this.showSupportMessages) {
        return true;
      }
      return this.currentPartner.deleted_at !== null;
    },
    partnerInfoText() {
      if (this.displayDialogInfo) {
        return "Profilinformationen verstecken";
      }
      return "Profilinformationen zeigen";
    }
  }
}
</script>
